import { render, staticRenderFns } from "./NewIncomeSourcesModule.vue?vue&type=template&id=6f71e3f0&"
import script from "./NewIncomeSourcesModule.vue?vue&type=script&lang=js&"
export * from "./NewIncomeSourcesModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports